import React from 'react';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import { deleteFile, downloadFile, uploadFile } from './fileUploadServices';
import type UploadContexts from './UploadContexts';

export type DownloadFile = (
  uploadId: string,
  fileName: string,
) => ReturnType<typeof downloadFile>;
export type RemoveFile = (uploadId: string) => ReturnType<typeof deleteFile>;
export type UploadFile = (file: File) => ReturnType<typeof uploadFile>;

const useFileUpload = (context: UploadContexts) => {
  const ownerOrgId = useOwnerOrgId();

  const download: DownloadFile = React.useCallback(
    (uploadId, fileName) =>
      downloadFile({ context, ownerOrgId, uploadId }, fileName),
    [context, ownerOrgId],
  );

  const remove: RemoveFile = React.useCallback(
    (uploadId) => deleteFile({ context, ownerOrgId, uploadId }),
    [context, ownerOrgId],
  );

  const upload: UploadFile = React.useCallback(
    (file) => uploadFile(file, { context, ownerOrgId }),
    [context, ownerOrgId],
  );

  return { download, remove, upload };
};

export default useFileUpload;
